import { createSlice } from "@reduxjs/toolkit";
import {
  resolveCaseRoleAccessAction,
  getByIdCaseRoleAccessAction,
  saveCaseRoleAccessAction,
  listCaseRoleAccessAction,
  setActiveCaseRoleAccessAction,
  deleteCaseRoleAccessAction,
} from "../../actions/CaseRoleAccess/caseRoleAccessAction";

const initialState = {
  loading: false,
  error: null,
  list: [],
  total: 0,
  currentConfig: null,
  resolvedConfig: null,
  resolvedKey: null,
  loadingKey: null,
  configsByKey: {},
};

const caseRoleAccessSlice = createSlice({
  name: "caseRoleAccess",
  initialState,
  reducers: {
    clearCurrentConfig: (state) => {
      state.currentConfig = null;
    },
    clearResolvedConfig: (state) => {
      state.resolvedConfig = null;
      state.resolvedKey = null;
      state.loadingKey = null;
      state.configsByKey = {};
    },
  },
  extraReducers: (builder) => {
    builder
      // Resolve
      .addCase(resolveCaseRoleAccessAction.pending, (state, action) => {
        state.loading = true;
        state.error = null;
        const arg = action.meta?.arg;
        state.loadingKey = arg ? `${Number(arg.organization_id)}_${Number(arg.role_id)}_${Number(arg.caseType)}` : null;
      })
      .addCase(resolveCaseRoleAccessAction.fulfilled, (state, action) => {
        state.loading = false;
        state.resolvedConfig = action.payload;
        const arg = action.meta?.arg;
        const key = arg ? `${Number(arg.organization_id)}_${Number(arg.role_id)}_${Number(arg.caseType)}` : null;
        state.resolvedKey = key;
        state.loadingKey = null;
        if (key) {
          state.configsByKey = {
            ...state.configsByKey,
            [key]: action.payload || null,
          };
        }
      })
      .addCase(resolveCaseRoleAccessAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.resolvedConfig = null;
        const arg = action.meta?.arg;
        const key = arg ? `${Number(arg.organization_id)}_${Number(arg.role_id)}_${Number(arg.caseType)}` : null;
        state.resolvedKey = key;
        state.loadingKey = null;
        if (key) {
          state.configsByKey = {
            ...state.configsByKey,
            [key]: null,
          };
        }
      })

      // Get By ID
      .addCase(getByIdCaseRoleAccessAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getByIdCaseRoleAccessAction.fulfilled, (state, action) => {
        state.loading = false;
        state.currentConfig = action.payload;
      })
      .addCase(getByIdCaseRoleAccessAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Save
      .addCase(saveCaseRoleAccessAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(saveCaseRoleAccessAction.fulfilled, (state, action) => {
        state.loading = false;
        state.currentConfig = action.payload;
      })
      .addCase(saveCaseRoleAccessAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // List
      .addCase(listCaseRoleAccessAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(listCaseRoleAccessAction.fulfilled, (state, action) => {
        state.loading = false;
        const items = action.payload?.items || action.payload || [];
        state.list = items;
        state.total = action.payload?.total ?? items.length;
      })
      .addCase(listCaseRoleAccessAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Set Active
      .addCase(setActiveCaseRoleAccessAction.fulfilled, (state, action) => {
        const { id, isActive } = action.payload;
        state.list = state.list.map((item) =>
          item.id === id ? { ...item, isActive } : item
        );
        if (state.currentConfig?.id === id) {
          state.currentConfig.isActive = isActive;
        }
      })

      // Delete
      .addCase(deleteCaseRoleAccessAction.fulfilled, (state, action) => {
        const id = action.payload;
        state.list = state.list.filter((item) => item.id !== id);
        if (state.currentConfig?.id === id) {
          state.currentConfig = null;
        }
      });
  },
});

export const { clearCurrentConfig, clearResolvedConfig } = caseRoleAccessSlice.actions;
export default caseRoleAccessSlice.reducer;
